var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-badge',{staticClass:"tag-badge mr-1"},[_vm._v(" "+_vm._s(_vm.tag.nom)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }